import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { CacheService } from '../_services/cache.service'
import { Scope } from '../_models'

export const WATCHDOG_AUTH_KEY = 'watchdog-auth'
const signInUrl = '/auth/sign-in'
const unauthorizedUrl = '/speedbox/unauthorized'
const watchdogRoot = '/watchdog-dashboard'

/**
 * Signed-out visitors keep their intended watchdog link across the sign-in
 * flow; signed-in non-admins are turned away as before.
 */
export const watchdogAuthGuard: CanActivateFn = async (_route, state) => {
  const router = inject(Router)
  const cache = inject(CacheService)

  const user =
    (await cache.getActiveUser()) ?? (await cache.resumeSession().catch(() => undefined))

  if (!user) {
    localStorage.setItem(WATCHDOG_AUTH_KEY, state.url)
    return router.parseUrl(signInUrl)
  }

  if (user.hasRole([Scope.GLOBAL_ADMIN])) {
    return true
  }

  localStorage.removeItem(WATCHDOG_AUTH_KEY)
  return router.parseUrl(unauthorizedUrl)
}

/**
 * Returns a stored watchdog destination once, so a stale entry cannot hijack
 * later sign-ins. Anything outside the watchdog feature is discarded.
 */
export function takeWatchdogReturnUrl(): string | null {
  const stored = localStorage.getItem(WATCHDOG_AUTH_KEY)
  if (!stored) return null
  localStorage.removeItem(WATCHDOG_AUTH_KEY)
  return stored === watchdogRoot || stored.startsWith(`${watchdogRoot}?`) ||
    stored.startsWith(`${watchdogRoot}/`)
    ? stored
    : null
}
